import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { pageIdZodSchema } from "@@/shared/pages/page-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const setGlobalHomeSettingCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("SET_GLOBAL_HOME_SETTING_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    /** A global page id or null, when null it sets home to old hard coded default page */
    pageId: pageIdZodSchema.nullable(),
});

type SetGlobalHomeSettingCommand = z.infer<
    typeof setGlobalHomeSettingCommandZodObject
>;

const setGlobalHomeSettingCommandFactoryParamsZodObject =
    setGlobalHomeSettingCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof setGlobalHomeSettingCommandFactoryParamsZodObject
>;
const setGlobalHomeSettingCommandFactory = (
    params: FactoryParams,
): SetGlobalHomeSettingCommand => {
    const command: SetGlobalHomeSettingCommand = {
        ...params,
        _id: generateId({ prefix: "set_global_home_setting_command__" }),
        _type: "SET_GLOBAL_HOME_SETTING_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export {
    setGlobalHomeSettingCommandFactory,
    setGlobalHomeSettingCommandFactoryParamsZodObject,
    setGlobalHomeSettingCommandZodObject,
};
export type {
    SetGlobalHomeSettingCommand,
    FactoryParams as SetGlobalHomeSettingCommandFactoryParams,
};
